
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/participation/visitors",
      function () {
        return require("private-next-pages/participation/visitors.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/participation/visitors"])
      });
    }
  